import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import perguntasReacao from '../data/avaliacaoReacao.json';

function ModalAvaliacaoReacao({ show, data, onHide }) {
    const [formattedData, setFormattedData] = useState({ questoes: [], respostas: [] });
    
    useEffect(() => {
        if (data && data.respostas) {
            try {
                
                // Tentar converter as respostas se elas vierem como string JSON
                let respostasObj = typeof data.respostas === 'string' ? JSON.parse(data.respostas) : data.respostas;
                
                // Transformar em arrays para exibição
                const questoesArray = [];
                const respostasArray = [];
                
                // Se é um objeto, extrair as chaves (questões) e valores (respostas)
                if (typeof respostasObj === 'object' && !Array.isArray(respostasObj)) {
                    Object.entries(respostasObj).forEach(([idQuestao, resposta]) => {
                        // Buscar a questão no arquivo JSON
                        const pergunta = perguntasReacao.find(q => q.id.toString() === idQuestao);
                        const textoQuestao = pergunta ? pergunta.questao : `Questão ${idQuestao}`;
                        
                        questoesArray.push(textoQuestao);
                        respostasArray.push(resposta);
                    });
                } else if (Array.isArray(respostasObj)) {
                    // Se já é um array, mapear direto
                    respostasObj.forEach((item, index) => {
                        const pergunta = perguntasReacao[index] || { questao: `Questão ${index + 1}` };
                        questoesArray.push(pergunta.questao);
                        respostasArray.push(item);
                    });
                }
                
                setFormattedData({
                    questoes: questoesArray,
                    respostas: respostasArray
                });
            } catch (error) {
                console.error("Erro ao processar respostas da avaliação de reação:", error);
                setFormattedData({ questoes: [], respostas: [] });
            }
        }
    }, [data]);

    return (
        <Modal size="lg" show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <span className="fw-semibold fs-5 text-primary">Avaliação de Reação</span>
            </Modal.Header>
            <Modal.Body className="bg-gray-100 p-4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="body">
                                <div className="d-flex">
                                    <div className="d-flex flex-column w-100">
                                        <div className="row">
                                            <div className="col-12 mb-3">
                                                <h5 className="fw-semibold">{data && data.nomeModulo}</h5>
                                                <p className="text-muted">Data: {data && data.data_formatada}</p>
                                            </div>
                                            
                                            <div className="col-12">
                                                {formattedData.questoes.length > 0 ? (
                                                    <div className="table-responsive">
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col" style={{ width: '70%' }}>Questão</th>
                                                                    <th scope="col" style={{ width: '30%' }}>Resposta</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {formattedData.questoes.map((questao, index) => {
                                                                    // Encontrar o tipo de questão
                                                                    const perguntaOriginal = perguntasReacao.find(p => p.questao === questao);
                                                                    const tipo = perguntaOriginal ? perguntaOriginal.tipo : 'escala';
                                                                    
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>{questao}</td>
                                                                            <td>
                                                                                <span className={`badge ${
                                                                                    tipo === 'sim_nao' 
                                                                                        ? formattedData.respostas[index] === 'Sim' 
                                                                                            ? 'bg-success' 
                                                                                            : 'bg-danger'
                                                                                        : getBadgeColor(formattedData.respostas[index])
                                                                                } text-white`}>
                                                                                    {formattedData.respostas[index]}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ) : (
                                                    <div className="alert alert-info">
                                                        Não foram encontradas respostas para esta avaliação.
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-end">
                <div className="d-flex justify-content-end">
                    <button 
                        type="button" 
                        className="btn btn-primary" 
                        onClick={onHide}
                    >
                        Fechar
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

// Função auxiliar para determinar a cor do badge com base na resposta
function getBadgeColor(resposta) {
    if (resposta.includes('Excelente') || resposta.includes('5 -')) return 'bg-success';
    if (resposta.includes('Muito Bom') || resposta.includes('4 -')) return 'bg-primary';
    if (resposta.includes('Satisfatório') || resposta.includes('3 -')) return 'bg-info';
    if (resposta.includes('Regular') || resposta.includes('2 -')) return 'bg-warning';
    if (resposta.includes('Insatisfatório') || resposta.includes('1 -')) return 'bg-danger';
    return 'bg-secondary';
}

export default ModalAvaliacaoReacao; 